(()=>{
  // Discovery is article search, not an exact-tag filter.
  const topics={
    travel:'travel OR trip OR destination OR visit OR hiking OR waterfall OR beach OR lake OR cave OR hotel OR Arizona OR Utah OR Oregon OR California OR Idaho OR Arkansas OR "New Mexico" OR Illinois OR "New England"',
    'photo-stories':'photography OR photos OR camera OR landscape OR sunset OR wildlife',
    'creator-tips':'photography OR camera OR lens OR editing OR lighting OR gear OR calibration',
    hiking:'hiking OR hike OR trail OR outdoors OR camping OR summit OR canyon',
    'food-drink':'restaurant OR pizza OR brewery OR taproom OR dining OR food OR cafe OR breakfast',
    arizona:'Arizona OR Tucson OR Sedona OR Flagstaff OR Phoenix OR Havasupai OR "Mount Lemmon" OR "Canyon Lake" OR "Roosevelt Lake" OR "Wave Cave" OR "Weavers Needle"',
    idaho:'Idaho OR "Idaho Falls" OR "Mesa Falls" OR "Craters of the Moon" OR "Mammoth Cave"',
    arkansas:'Arkansas OR Bentonville OR Rogers OR "Eureka Springs" OR "Cosmic Cavern" OR "Crescent Hotel"',
    utah:'Utah OR Zion OR Bryce OR "Cedar Breaks" OR "Brian Head" OR "Lake Powell"',
    oregon:'Oregon OR Florence OR "Silver Falls" OR "Sea Lion Caves"',
    california:'California OR "Big Bear" OR Laguna OR Irvine OR "Dana Point"',
    'new-mexico':'"New Mexico" OR "White Sands" OR Carlsbad',
    illinois:'Illinois OR Chicago',
    'new-england':'"New England" OR Vermont OR Maine OR Massachusetts OR "New Hampshire"',
    hotels:'hotel OR lodging OR resort OR inn OR stay',
    'national-parks':'"national park" OR "national monument" OR preserve',
    waterfalls:'waterfall OR waterfalls OR falls',
    caves:'cave OR cavern OR caverns',
    family:'family OR kids OR children'
  };
  const tagSearch=pathname=>{
    const match=pathname.match(/^\/blogs\/news\/tagged\/([^/]+)\/?$/);
    if(!match) return null;
    const tag=decodeURIComponent(match[1]);
    const query=topics[tag]||tag.replace(/[-+]/g,' ');
    return '/search?type=article&q='+encodeURIComponent(query);
  };
  const legacySearch=tagSearch(window.location.pathname);
  if(legacySearch){ window.location.replace(legacySearch); return; }
  const exact=new Map([
    ['/pages/about','tb-about'],
    ['/pages/contact','tb-contact'],
    ['/pages/services','tb-services'],
    ['/collections/all','tb-shop']
  ]);
  // These published layouts have been verified at their clean URLs.
  const published=new Map([
    ['/blogs/news','tb-journal'],
    ['/blogs/news/havasupai-waterfalls','tb-havasupai'],
    ['/blogs/news/bryce-canyon-national-park','tb-bryce'],
    ['/blogs/news/fremont-saddle-weavers-needle-arizona','tb-weavers']
    ,['/blogs/news/wave-cave-arizona','tb-wave-cave']
    ,['/blogs/news/cosmic-cavern-berryville-arkansas','tb-cosmic-cavern']
    ,['/blogs/news/idaho-falls-five-places','tb-idaho-falls']
  ]);
  const viewFor=pathname=>{
    const clean=pathname.length>1?pathname.replace(/\/$/,''):pathname;
    if(exact.has(clean)) return exact.get(clean);
    return null;
  };
  const update=root=>{
    const links=root.querySelectorAll?root.querySelectorAll('a[href]'):[];
    links.forEach(link=>{
      const raw=link.getAttribute('href');
      if(!raw||raw.startsWith('#')||raw.startsWith('mailto:')||raw.startsWith('tel:')) return;
      let url;
      try{url=new URL(raw,window.location.origin);}catch(error){return;}
      if(url.origin!==window.location.origin) return;
      const search=tagSearch(url.pathname);
      if(search){ link.setAttribute('href',search); return; }
      const currentView=url.searchParams.get('view');
      const cleanPath=url.pathname.replace(/\/$/,'');
      const publishedView=published.get(cleanPath)||(cleanPath.startsWith('/blogs/news/tagged/')?'tb-journal':null);
      if(publishedView){
        if(currentView===publishedView||(published.has(cleanPath)&&cleanPath.startsWith('/blogs/news/')&&currentView==='tb-story')){
          url.searchParams.delete('view');
          link.setAttribute('href',url.pathname+url.search+url.hash);
        }
        return;
      }
      if(currentView) return;
      const view=viewFor(url.pathname);
      if(!view) return;
      url.searchParams.set('view',view);
      link.setAttribute('href',url.pathname+url.search+url.hash);
    });
    document.documentElement.setAttribute('data-tb-draft-routes','active');
  };
  const start=()=>update(document);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',event=>update(event.target));
})();

(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let observer;
  const titleSelector = '.tb-home .tb-heading h2, .tb-home .tb-about__copy h2, .tb-ed__copy > h2, .tb-kit--layout-cards .tb-kit__header h2, .tb-kit--layout-split .tb-kit__copy > h2';
  const observe = (root) => {
    root.querySelectorAll(titleSelector).forEach(title => {
      if (title.classList.contains('tb-quiet-title')) return;
      title.classList.add('tb-quiet-title');
      if (!reduced.matches && 'IntersectionObserver' in window) {
        if (!observer) observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              entry.target.classList.add('tb-motion-seen');
              observer.unobserve(entry.target);
            }
          });
        }, { threshold:0.2 });
        title.classList.add('tb-motion-ready');
        observer.observe(title);
      }
    });
    root.querySelectorAll('.tb-home .tb-about__media, .tb-ed__portrait, .tb-kit__media, .tb-ed__media, .tb-card-media, .tb-jr__feature-media, .tb-jr__card-photo, .tb-jr__cover').forEach(photo => {
      if (photo.querySelector('img') && !photo.closest('.tb-layered-photo, .tb-kit--hero') && !photo.querySelector('video, iframe')) photo.classList.add('tb-layered-photo');
    });
  };
  const start = () => observe(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => observe(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (observer) event.target.querySelectorAll('.tb-motion-ready').forEach(title => observer.unobserve(title));
  });
  reduced.addEventListener('change', event => {
    if (event.matches) {
      if (observer) observer.disconnect();
      document.querySelectorAll('.tb-motion-ready').forEach(title => title.classList.add('tb-motion-seen'));
    }
  });
})();

(() => {
  if (document.querySelector('.tb-photo-dialog')) return;
  const init = () => {
    const photos = [...document.querySelectorAll('.tb-jr__prose img')].filter(img => !img.closest('a,button'));
    if (!photos.length || typeof HTMLDialogElement === 'undefined') return;
    const dialog = document.createElement('dialog');
    dialog.className = 'tb-photo-dialog';
    dialog.setAttribute('aria-label', 'Story photo viewer');
    const bar = document.createElement('div');
    bar.className = 'tb-photo-dialog__bar';
    const makeButton = (label, action) => {
      const button = document.createElement('button');
      button.type = 'button'; button.textContent = label;
      button.addEventListener('click', action); bar.append(button);
      return button;
    };
    let index = 0, opener, previousOverflow;
    const image = document.createElement('img');
    const caption = document.createElement('p');
    caption.setAttribute('aria-live', 'polite');
    const show = next => {
      index = (next + photos.length) % photos.length;
      const original = photos[index];
      image.src = original.currentSrc || original.src;
      image.alt = original.alt || '';
      const text = original.closest('figure')?.querySelector('figcaption')?.textContent.trim() || original.alt || '';
      caption.textContent = `${index + 1} / ${photos.length}${text ? ' · ' + text : ''}`;
    };
    const previous = makeButton('← Previous', () => show(index - 1));
    const next = makeButton('Next →', () => show(index + 1));
    const close = makeButton('Close ×', () => dialog.close());
    previous.hidden = next.hidden = photos.length < 2;
    dialog.append(bar, image, caption); document.body.append(dialog);
    dialog.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(index + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      opener?.focus();
    });
    photos.forEach((photo, position) => {
      photo.tabIndex = 0; photo.setAttribute('role', 'button');
      photo.setAttribute('aria-haspopup', 'dialog');
      photo.setAttribute('aria-label', 'Enlarge photo' + (photo.alt ? ': ' + photo.alt : ''));
      photo.classList.add('tb-photo-zoom');
      const host = photo.parentElement;
      host.classList.add('tb-photo-cue-host');
      const cue = document.createElement('span');
      cue.className = 'tb-photo-cue';
      cue.textContent = 'View larger ↗';
      cue.setAttribute('aria-hidden', 'true');
      photo.after(cue);
      const placeCue = () => {
        cue.style.left = (photo.offsetLeft + photo.offsetWidth - 12) + 'px';
        cue.style.top = (photo.offsetTop + photo.offsetHeight - 12) + 'px';
      };
      photo.addEventListener('load', placeCue);
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(placeCue);
        observer.observe(photo);
        observer.observe(host);
      } else window.addEventListener('resize', placeCue);
      requestAnimationFrame(placeCue);
      const open = () => {
        opener = photo; show(position);
        previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        dialog.showModal(); close.focus();
      };
      photo.addEventListener('click', open);
      photo.addEventListener('keydown', event => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); open(); }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
